import { render, staticRenderFns } from "./SearchFenex.vue?vue&type=template&id=8a0e5a96&scoped=true&"
import script from "./SearchFenex.vue?vue&type=script&lang=js&"
export * from "./SearchFenex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0e5a96",
  null
  
)

export default component.exports